import { createContext, useContext } from "react";

export type Project = {
  id: string;
  name: string;
  description: string | null;
  productUrl: string | null;
  repositoryUrl: string | null;
  githubRepositoryId?: string | null;
  tenantId: string;
  createdAt: string;
  updatedAt: string;
};

/**
 * Provided by ProjectShell — always contains a validated project.
 * Components outside ProjectShell will get null from the raw context.
 */
export const ProjectContext = createContext<Project | null>(null);

/**
 * Returns the current project from ProjectShell context.
 * Throws if used outside a ProjectShell route.
 */
export function useProject(): Project {
  const project = useContext(ProjectContext);
  if (!project) {
    throw new Error("useProject must be used within a ProjectShell route");
  }
  return project;
}

/**
 * Returns the current project or null. Safe to use outside ProjectShell
 * (e.g., sidebar that renders on both global and project-scoped routes).
 */
export function useOptionalProject(): Project | null {
  return useContext(ProjectContext);
}
